import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";
import "@/i18n";
import "@/App.css";

import Layout from "@/components/Layout";
import BrowsePage from "@/pages/BrowsePage";
import SessionDetailPage from "@/pages/SessionDetailPage";
import MyBookingsPage from "@/pages/MyBookingsPage";
import MediaPage from "@/pages/MediaPage";
import AdminPage from "@/pages/AdminPage";
import ScannerPage from "@/pages/ScannerPage";

axios.defaults.withCredentials = true;

function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  React.useEffect(() => {
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/", { replace: true }); return; }
    const sessionId = m[1];
    (async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/admin?err=1", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center text-slate-500 font-mono-diplo text-xs">
      Signing you in…
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<BrowsePage />} />
        <Route path="/session/:id" element={<SessionDetailPage />} />
        <Route path="/my-bookings" element={<MyBookingsPage />} />
        <Route path="/media" element={<MediaPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/scanner" element={<ScannerPage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  useEffect(() => { document.title = "EventHub · Dakar 2026"; }, []);
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster richColors position="top-center" />
    </BrowserRouter>
  );
}
